export const REGISTER_USER = 'REGISTER_USER';
export const LOGIN_USER = "LOGIN_USER";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const FETCH_USER = "FETCH_USER";
export const REGISTRATION_CODE_ERROR = "REGISTRATION_CODE_ERROR";
